/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import Button from "../../component/button/Button";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import SelectInput from "../../component/input/SelectInput";
import {
  isSuperAdmin,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";
import TextInput from "../../component/input/TextInput";

const AddDeviceModal = ({
  values,
  onSubmit,
  userLoading,
  currentUser,
  allLocations,
  onChange
}) => {
  return (
    <div
      className="modal fade"
      id="add_device"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="fullWidthModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-full-width">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="fullWidthModalLabel">
              Add Devices
            </h4>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>

          <form className="pl-3 pr-3" onSubmit={onSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <h4 className="mt-1">Add Employee Access</h4>
                  <p className="text-muted mb-2">
                    Fill the form below to Add Access .
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <SelectInput
                    required={true}
                    textWhite={false}
                    isLabeled={false}
                    onChange={onChange}
                    label="Select Location"
                    name="selectedLocationId"
                    value={values.selectedLocationId}
                  >
                    <option value=""> Select Location</option>
                    {isSuperAdmin(currentUser)
                      ? renderLocationFunction(allLocations)
                      : renderAccessLocation2(
                          JSON.parse(
                            localStorage.getItem("selectedModule")
                          )
                        )}
                  </SelectInput>
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <TextInput
                    type="text"
                    required={true}
                    textWhite={false}
                    name="workerName"
                    onChange={onChange}
                    htmlFor="workerName"
                    value={values.workerName}
                    label="Employee / Worker Full Name"
                    placeholder="Employee / Worker Full Name"
                  />
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <TextInput
                    type="text"
                    required={true}
                    textWhite={false}
                    onChange={onChange}
                    name="workerNumber"
                    htmlFor="workerNumber"
                    value={values.workerNumber}
                    label="Employee / Worker Number"
                    placeholder="Employee / Worker Number"
                  />
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <TextInput
                    type="text"
                    required={true}
                    name="workerId"
                    textWhite={false}
                    htmlFor="workerId"
                    onChange={onChange}
                    value={values.workerId}
                    label="Employee / Worker Id"
                    placeholder="Employee / Worker Id"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <TextInput
                    type="text"
                    required={true}
                    textWhite={false}
                    name="deviceName"
                    onChange={onChange}
                    htmlFor="deviceName"
                    label="Enter Device Name"
                    value={values.deviceName}
                    placeholder="Enter Device Name"
                  />
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <TextInput
                    type="text"
                    required={true}
                    name="modelName"
                    textWhite={false}
                    htmlFor="modelName"
                    onChange={onChange}
                    label="Enter Model Name"
                    value={values.modelName}
                    placeholder="Enter Model Name"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="button"
                title="Close"
                data-dismiss="modal"
                className="btn btn-light"
                isBackgroundColor={false}
              />
              {userLoading ? (
                <SpinnerButton />
              ) : (
                <Button
                  type="submit"
                  title="Add Devices"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                  className="btn text-white btn-dark"
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

AddDeviceModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  userLoading: PropTypes.bool.isRequired,
  allLocations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default AddDeviceModal;
